document.addEventListener('DOMContentLoaded', () => {
  if (!window.gsap) return

  const { gsap } = window

  const section = document.querySelector('[data-heritage-intro-section]')
  if (!section) return

  const title = section.querySelector('[data-heritage-intro-title]')
  const titleLines = Array.from(section.querySelectorAll('[data-heritage-intro-line]'))
  const label = section.querySelector('[data-heritage-intro-label]')
  const image = section.querySelector('[data-heritage-intro-image]')
  const imageMedia = section.querySelector('[data-heritage-intro-image-media]')
  const lead = section.querySelector('[data-heritage-intro-lead]')
  const body = section.querySelector('[data-heritage-intro-body]')

  const items = [label, image, lead, body].filter(Boolean)

  const reset = () => {
    items.forEach((item) => {
      gsap.set(item, { y: 20, opacity: 0 })
    })
    if (titleLines.length) gsap.set(titleLines, { yPercent: 120, opacity: 0 })
    if (imageMedia) gsap.set(imageMedia, { scale: 1.08, transformOrigin: 'center center' })
  }

  reset()

  const reveal = () => {
    title?.classList.remove('opacity-0')

    const tl = gsap.timeline({ delay: 0.3 })

    if (titleLines.length) {
      tl.to(
        titleLines,
        {
          yPercent: 0,
          opacity: 1,
          duration: 0.9,
          ease: 'power3.out',
          stagger: 0.12,
        },
        0,
      )
    }

    if (imageMedia) {
      tl.to(
        imageMedia,
        {
          scale: 1,
          duration: 1.3,
          ease: 'power3.out',
        },
        0,
      )
    }

    if (items.length) {
      tl.to(
        items,
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: 'power3.out',
          stagger: 0.1,
        },
        0.1,
      )
    }
  }

  if (window.ScrollTrigger) {
    window.ScrollTrigger.create({
      trigger: section,
      start: 'top 80%',
      onEnter: reveal,
    })
    window.ScrollTrigger.create({
      trigger: section,
      start: 'top bottom',
      onLeaveBack: reset,
    })

    requestAnimationFrame(() => {
      const rect = section.getBoundingClientRect()
      if (rect.top < window.innerHeight * 0.85) reveal()
    })

    section.querySelectorAll('[data-heritage-intro-parallax]').forEach((el) => {
      const wrap = el.closest('.overflow-hidden') || el.parentElement
      gsap.set(el, { scale: 1.25 })
      gsap.fromTo(
        el,
        { yPercent: 8 },
        {
          yPercent: -8,
          ease: 'none',
          scrollTrigger: {
            trigger: wrap,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
          },
        },
      )
    })
  } else {
    reveal()
  }
})
